import PropTypes from 'prop-types';

export default function VisibilityScheme() { }

VisibilityScheme.propTypes = {
  lg: PropTypes.bool,
  md: PropTypes.bool,
  sm: PropTypes.bool,
  xl: PropTypes.bool,
  xs: PropTypes.bool,
};

VisibilityScheme.graphQlSchema = `
  lg,
  md,
  sm,
  xl,
  xs,
`;
